<template>
    <div>
        <member-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                            :paginationData="filterSet.page"></member-filter-link>
        <member-list-link :listLayout="listLayout" :paginationData="filterSet.page"
                          :memberData="List"></member-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page" :listLength="List.length"
                        ></pagination-link>
    </div>
</template>

<script>
    import MemberFilterLink from "@/components/member/MemberFilterLink";
    import MemberListLink from "@/components/member/MemberListLink";
    import PaginationLink from "@/components/member/PaginationLink";
    import memberUtil from "@/components/member/memberUtil";
    import filterMixins from "@/mixins/filterMixins";
    import listMixins from "@/mixins/listMixins";
    import util from "@/mixins/util";
    import alertMixins from "@/mixins/alertMixins";
    import EventBus from "@/utils/event-bus";

    const {filterConfig} = memberUtil;

export default {
    name: "MemberListComponent",
    mixins: [memberUtil, filterMixins, listMixins, alertMixins],
    components: {MemberFilterLink, MemberListLink, PaginationLink},
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            memberListSetData: this.setData,
            changeAllow: this.runChangeAllow,
        }
    },
    inject: ['changeLoading'],
    props: {
        memberType: {default: ''},
    },
    data() {
        return {
            getFunc: null,
            listLayout: '',
            filterLayout: '',
            paginationLayout: '',
            listApiParamSet: {},
        }
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        this.getList(true);

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initConfig() {
            let config = this.returnMemberConfig(this.memberType)
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.paginationLayout = config.paginationLayout;
            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet;
            let listOptions = {
                url: this.$api.$member[this.getFunc],
                defaultParams: this.listApiParamSet,
            }
            if (config.pageRow && config.pageRow != this.filterSet.page.size) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }

            this.initList('api', listOptions);
        },
        runChangeAllow(type = 'allow', key) {
            if (type === 'allow') {
                this.allowMember(key);
            } else {
                this.refuseMember(key);
            }
        },
        allowMember(key) {
            let params = {
                c_idx: key,
            }
            try {
                this.changeLoading(true)
                this.$api.$member.approveCurator(params).then(res => res.Data.Result).then(res => {
                    this.changeLoading(false)
                    let type = this.returnAllowType(res.Info.type);
                    if (type === true) {
                        this.getList();
                        this.createAlert({
                            content: '승인되었습니다.',
                        })

                    } else {
                        this.errorAlert(type);
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        returnAllowType(type) {
            switch (type) {
                case 1:
                    return true;
                case  -202:
                    return '권한이 없습니다.'
                default:
                    return '승인 실패하였습니다.';
            }
        },
        refuseMember(key) {
            let params = {
                c_idx: key,
            }
            try {
                this.changeLoading(true)
                this.$api.$member.refuseCurator(params).then(res => res.Data.Result).then(res => {
                    this.changeLoading(false)
                    if (res.Info.type === 1) {
                        this.getList();
                        this.createAlert({
                            content: '거절되었습니다.',
                        })
                    } else {
                        this.errorAlert('거절 실패하였습니다.');
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        returnRejectType(type) {
            switch (type) {
                case 1:
                    return true;
                case  -202:
                    return '권한이 없습니다.'
                default:
                    return '거절 실패하였습니다.';
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
